import React from "react";
import ReactDOM from "react-dom";
import createStore from "./store/createStore";
import "./styles/main.scss";
import { initialize, addTranslationForLanguage } from "react-localize-redux";
import { loadState, saveState } from "./localStorage";
import {
  cartState,
  categoryState,
  commonState,
  customerState,
  productState,
  orderState
} from "./store/stateModel";

// Store Initialization
// ------------------------------------
// export const store = createStore(window.__INITIAL_STATE__);
const persistedState = loadState();
let initialState = {
  common: persistedState !== undefined ? persistedState.common : commonState,
  category: categoryState,
  product: productState,
  cart: cartState,
  order: orderState,
  customer:
    persistedState !== undefined ? persistedState.customer : customerState
};
export const store = createStore(initialState);
// const store = createStore(window.__INITIAL_STATE__);

store.subscribe(() => {
  saveState({
    common: store.getState().common,
    customer: store.getState().customer
  });
});

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById("root");

let render = () => {
  const App = require("./components/App").default;
  const routes = require("./routes/index").default(store);

  //translation
  const languages = [
    { name: "English", code: "gb", id: 2 },
    { name: "Magyar", code: "hu", id: 3 },
    { name: "Slovenský", code: "sk", id: 1 }
  ];
  store.dispatch(initialize(languages));

  const en = require("./locale/en.json");
  store.dispatch(addTranslationForLanguage(en, "gb"));
  const hu = require("./locale/hu.json");
  store.dispatch(addTranslationForLanguage(hu, "hu"));
  const sk = require("./locale/sk.json");
  store.dispatch(addTranslationForLanguage(sk, "sk"));

  ReactDOM.render(<App store={store} routes={routes} />, MOUNT_NODE);
};

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      const RedBox = require("redbox-react").default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept(["./components/App", "./routes/index"], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      })
    );
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render();



// WEBPACK FOOTER //
// ./src/main.js